var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentLoader,{tag:"component",attrs:{"ot":_vm.ot,"prms":_vm.prms}})
}
var staticRenderFns = []

export { render, staticRenderFns }